module.exports = __webpack_public_path__ + "static/media/TT Commons Trial Bold.2db38cfb.otf";